import "../css/card2.scss";

const Card2 = (props) => {
  const classname = "card-2 " + props.className ?? "";
  return <div className={classname}>{props.children}</div>;
};

export default Card2;
